import React from 'react';
import { PerformanceFlagRow } from './PerformanceFlagRow';
const meta = {
    title: 'Features/IAInsights/PerformanceFlagRow',
    component: PerformanceFlagRow,
    parameters: { layout: 'padded' },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: '900px', margin: '40px auto' } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const ProximityCheck = {
    args: {
        icon: 'fa-map-location-dot',
        title: 'Proximity Check',
        description: '4 issues across 3 inspections',
        lastOccurrence: 'Feb 27',
        buildings: ['Site 14', 'Site 22', 'Site 31']
    }
};
export const InspectionTimingAudit = {
    args: {
        icon: 'fa-clock',
        title: 'Inspection Timing Audit',
        description: '7 issues across 5 inspections',
        lastOccurrence: 'Mar 5',
        buildings: ['Acme Corp', 'Riverside Plaza']
    }
};
export const RecurringDeficiencies = {
    args: {
        icon: 'fa-arrows-repeat',
        title: 'Recurring Deficiencies',
        description: '12 issues across 8 inspections',
        lastOccurrence: 'Mar 1',
        buildings: ['Building A', 'Building B', 'Building C', 'Building D']
    }
};
export const WithoutDetails = {
    args: {
        icon: 'fa-cubes',
        title: 'Asset Count Changes',
        description: '2 issues across 2 inspections'
    }
};
export const AllFlags = {
    render: () => (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '8px' } },
        React.createElement(PerformanceFlagRow, { icon: "fa-map-location-dot", title: "Proximity Check", description: "4 issues across 3 inspections", lastOccurrence: "Feb 27", buildings: ['Site 14', 'Site 22', 'Site 31'] }),
        React.createElement(PerformanceFlagRow, { icon: "fa-clock", title: "Inspection Timing Audit", description: "7 issues across 5 inspections", lastOccurrence: "Mar 5", buildings: ['Acme Corp', 'Riverside Plaza'] }),
        React.createElement(PerformanceFlagRow, { icon: "fa-cubes", title: "Asset Count Changes", description: "2 issues across 2 inspections" }),
        React.createElement(PerformanceFlagRow, { icon: "fa-triangle-exclamation", title: "Unresolved Prior Deficiencies", description: "9 issues across 6 inspections", lastOccurrence: "Feb 20", buildings: ['Main Hospital', 'East Wing', 'West Wing', 'Annex', 'Parking Deck'] }),
        React.createElement(PerformanceFlagRow, { icon: "fa-arrows-repeat", title: "Recurring Deficiencies", description: "12 issues across 8 inspections", lastOccurrence: "Mar 1", buildings: ['Building A'] })))
};
